// frontend/src/api/backups.js
import { apiClient } from './index';

const backupsApi = {
  listBackups: async () => {
    return await apiClient.get('/backups/');
  },

  triggerManualBackup: async () => {
    return await apiClient.post('/backups/trigger', {});
  },

  restoreFromCloud: async (filename) => {
    return await apiClient.post('/backups/restore-from-cloud', { filename });
  },

  deleteBulk: async (filenames) => {
    // Ensure we send the body correctly for DELETE
    return await apiClient.delete('/backups/delete-bulk', { body: { filenames } });
  },

  // --- NEW ---
  downloadBackup: async (filename) => {
      return await apiClient.post('/backups/download', { filename });
  }
};

export { backupsApi };